module.exports = __webpack_public_path__ + "amcharts/images/dragIconRoundBigH.png";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=amcharts/images/[name].[ext]!./~/amstock3/amcharts/images/dragIconRoundBigH.png
// module id = 252
// module chunks = 0